// De marge van elke react-modal in deze app, op één plek.
//
// WAAROM DIT BESTAAT: dit stond als `margin: '5%'` op negen plekken gekopieerd,
// en het was op alle negen fout. Een procentuele marge lost in CSS altijd op
// tegen de BREEDTE van het omsluitende blok — ook boven en onder. Op een scherm
// van 1920 breed kostte dat 96px boven plus 96px onder, bovenop de 40px inset
// van react-modal zelf: een bredere monitor maakte elke modal dus LAGER, en bij
// de vragenselectie per meetmoment was de inhoud daardoor niet meer te bereiken.
// Verticaal moet de marge dus in px; horizontaal mag hij procentueel blijven,
// want daar rekent hij met de juiste as.
//
// Niet nog een keer los overnemen: `modalStyles.test.js` scant src/ en wordt
// rood zodra er ergens weer een `margin: '<n>%'` in een stijlobject staat.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
// AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
// Zie docs/inbox.md Bug #267 en #268.

/** Verticaal in px, horizontaal in procenten van de breedte. */
export const MODAL_MARGIN = '24px 5%';

/** Het volledige stijlobject voor common/Modal. */
const modalStyles = {
    content: {
        margin: MODAL_MARGIN,
        borderRadius: '8px',
    },
};

export default modalStyles;
